<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="'Add Invoice'" (addEvent)="addInvoicePopup($event)"> </app-breadcrumb>
    <div class="container-fluid"> 
        <div class="card">
            
            <div class="card-body p-0">            
                <div class="row p-3">
                    <div class="col-md-4 m-3">
                        <select class="form-select">
                            <option value="" disabled selected>Select Property</option>
                            <option>Visakhapatnam</option>
                            <option>Khammam</option>
                            <option>Anantapur</option>
                            <option>Hyderabad</option>
                        </select>
                    </div>                    
                    <!-- <div class="col-md-1 mt-4 p-0">                        
                        <button class="btn btn-primary btn-sm  float-start" type="submit">Search</button>
                    </div> -->                    
                </div>

                    <div class="row">
                        <div class="col-xl-12">
                        <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">  
                            <table id="empoloyees-tbl" class="table mb-0">
                                <thead>
                                    <tr>
                                        <th>Bill Name</th>
                                        <th>Bill Type</th>
                                        <th>Bill Amount</th>
                                        <th>Due Date</th>
                                        <th>Status</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for(item of allData.data; track item){
                                    <tr>
                                        <td>{{ item.document_name }}</td>
                                        <td>                    
                                            <span>{{ item.document_type }}</span>             
                                        </td>
                                        <td>{{ item.description }}</td>                                        
                                        <td class="text-center">
                                            <span class="badge badge-danger light border-0">Delete</span>
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                            <div class="dataTables_info" id="example5_info" role="status" aria-live="polite">Showing {{page}} to
                                {{totalRows}} of {{ allData.total }} entries</div>
                            <div class="dataTables_paginate paging_simple_numbers pt-2">
                                <app-pagination [totalPage]="totalPage" [page]="page" (newPage)="pageChange($event)"></app-pagination>
                            </div>
                        </div>               

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div #addInvoiceButton class="offcanvas offcanvas-end customeoff {{ property_invoice ? 'show':''}}" tabindex="-1" id="property_invoice" data-bs-backdrop="static">
    <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">Add Invoice</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" (click)="invoiceClose()">
          <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
        <form [formGroup]="addInvoiceForm" (ngSubmit)="onSubmit()" autocomplete="off"> 
      <div class="-fluid" > 
              <div class="row mb-5">
                  <div class="col-xl-12 mb-3">
                    <label for="exampleFormControlInput1-2" class="form-label">Properties<span class="text-danger">*</span></label>
                    <ng-select ngDefaultControl [items]="properties" 
                    class="select2" value="" placeholder="Select Properties" 
                    [typeahead]="searchInput$" [virtualScroll]="true"
                    formControlName="selectedBill" (scrollToEnd)="onScrollToEnd()">
                    <ng-template #template let-data="data">{{data?.name}}</ng-template>
                  </ng-select> 
                    <div *ngIf="addInvoiceForm?.get('property_name')?.invalid && addInvoiceForm?.get('property_name')?.touched" class="required">
                                      Property Name is required
                    </div>
                  </div>
                  <div class="col-xl-12 mb-3">
                    <label for="exampleFormControlInput1-2" class="form-label">Bills<span class="text-danger">*</span></label>
                    <input type="text" class="form-control" placeholder="Search for bills" formControlName="searchText" (input)="filterItems()" autocomplete="off">
                  </div>	
                  <div class="col-xl-12 mb-3">
                    <label for="exampleFormControlInput1-2" class="form-label">Select Bills</label>
                    <div class="row" formArrayName="bills">
                        <div class="col-12 col-sm-6 col-md-4 col-lg-4 d-flex justify-content-between sub-card" *ngFor="let bill of filteredItems; let i= index">
                            <div class="form-check custom-checkbox mb-2">
                                <input type="checkbox" class="form-check-input" [id]="bill.uid" [formControlName]="i">
                                <label class="form-check-label" [for]="bill.uid">{{bill.bill_name}} - {{bill.bill_type}} - {{bill.bill_amount}}</label>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="addInvoiceForm?.get('bills')?.invalid && addInvoiceForm?.get('bills')?.touched" class="required">
                        At least one bill must be selected.
                    </div>
                  </div>
              </div>
              <div>
                  <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="addInvoiceForm.invalid || loadingService.isLoading()">Submit</button>
                  <button class="btn btn-danger lightme-1" type="button" data-bs-dismiss="offcanvas" aria-label="Close"  (click)="invoiceClose()">Cancel</button>
              </div>
          
        </div>
        </form>
    </div>
  </div>		
@if(property_invoice){
    <div class="offcanvas-backdrop fade show" (click)="toggleInvoice()"></div>
}